import React, { useCallback, useEffect, useState } from 'react';
import FormsList from '../form-creations/FormsList';
import FormCategoriesList from '../form-creations/FormCategoriesList';
import { useSelector } from 'react-redux';
import DropdownField from '../../../shared/DropdownField';
import { useTranslation } from 'react-i18next';
import {
  formatFormsCategoriesOptionTypes,
  formatFormsListOptionTypes,
  formTypes
} from '../../../constants/FormCreationConstants';
import VisitFormResults from '../visits-form-entries/VisitFormResults';
import IPFormsList from './inpatientForms/IPFormsList';
import IpFormCategoryList from './inpatientForms/IpFormCategoryList';
import IpVisitFormResults from './inpatientForms/IpVisitFormResults';
import { fetchData } from '../../../helpers/fetchData';
import { filterFormsByRequestType, labModuleApi } from '../../../helpers/labModuleApi';

const IpFormEntriesCreation = props => {
  const { t } = useTranslation();
  const [selectedFormType, setSelectedFormType] = useState('inpatient');
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [formsLoading, setFormsLoading] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [formsData, setFormsData] = useState([]);
  const [formCategoriesData, setFormCategoriesData] = useState([]);
  const [selectedElementFormId, setSelectedElementFormId] = useState(null);
  const { selectedVisitData } = useSelector(state => state?.visits);
  const patientData = props?.patient;

  const fetchFormsData = useCallback(async () => {
    if (!selectedFormType) return;
    setFormsLoading(true);
    const response = await fetchData('GET', labModuleApi.forms.getAll());
    const filteredForms = filterFormsByRequestType(response?.data || [], selectedFormType);
    let formsData = filteredForms.length ? formatFormsListOptionTypes(filteredForms) : [];
    setFormsData(formsData);
    setFormsLoading(false);
  }, [selectedFormType]);

  const fetchCategories = useCallback(async () => {
    if (!selectedFormId) return;
    setCategoriesLoading(true);
    const response = await fetchData('GET', labModuleApi.categories.getAllByFormId(selectedFormId));
    let categoriesData = response?.data ? formatFormsCategoriesOptionTypes(response?.data) : [];
    setCategoriesLoading(false);
    setFormCategoriesData(categoriesData);
  }, [selectedFormId]);

  useEffect(() => {
    fetchFormsData();
  }, [selectedFormType]);

  useEffect(() => {
    fetchCategories();
  }, [selectedFormId, selectedFormType]);
  return (
    <div>
      <div className='w-full mt-2 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-1'>
        <DropdownField
          disabled={!selectedFormType}
          filter
          loading={formsLoading}
          label={t('Select form')}
          options={formsData}
          useFormik={false}
          placeholder={t('Select form')}
          value={selectedFormId}
          onChange={e => {
            setSelectedFormId(e.value);
          }}
        />
        <DropdownField
          filter
          disabled={!selectedFormId}
          loading={categoriesLoading}
          label={t('Select Category')}
          options={formCategoriesData}
          useFormik={false}
          placeholder={t('Select category')}
          value={selectedCategoryId}
          onChange={e => {
            setSelectedCategoryId(e.value);
          }}
        />
      </div>
      <div className='grid grid-cols-12 gap-3 mt-3'>
        {selectedCategoryId && (
          <div className='col-span-12'>
            <IpVisitFormResults
              selectedCategoryId={selectedCategoryId}
              selectedFormType={selectedFormType}
              visitId={selectedVisitData?.visit_id}
              patientId={patientData?.patient_id}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default IpFormEntriesCreation;
